import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingPageComponent } from './pages/tracking-page/tracking-page.component';
import { UnsubscribePageComponent } from './pages/unsubscribe-page/unsubscribe-page.component';

const routes: Routes = [
  { path: 'unsubscribe/:token', component: UnsubscribePageComponent, title: 'Unsubscribe' },
  { path: ':token', component: TrackingPageComponent },
  { path: '**', redirectTo: '/notfound' },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
